import type { Canvas, FabricObject } from 'fabric';
import { v4 as uuidv4 } from 'uuid';
import { isLayerObject } from '../canvas/utils/canvas-pieces';
import type { LayerId } from './types';

export const getOrAssignLayerId = (obj: FabricObject): LayerId => {
  if (obj.layerId) return obj.layerId;
  const id = uuidv4();
  obj.layerId = id;
  return id;
};

// Canvas objects indexed by their layer ID.
export const getObjectsByLayerId = (canvas: Canvas): Map<string, FabricObject> => {
  const map = new Map<string, FabricObject>();
  for (const obj of canvas.getObjects()) {
    if (!isLayerObject(obj)) continue;
    map.set(getOrAssignLayerId(obj), obj);
  }
  return map;
};
